import { createSlice } from '@reduxjs/toolkit';

/**
 * Helper to build the filter key consistently
 * @param {string} program - The program name
 * @param {string} product - The product name
 * @param {string} filterName - The filter name
 * @returns {string} The combined filter key
 */
export const keyOf = (program, product, filterName) =>
  `${program}_${product}_${filterName}`;

const initialState = {
  selectedValues: {}, // Store only selected values here
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    /**
     * Change the user-selected value for a filter
     */
    setFilterSelected: (state, action) => {
      const { program, product, filterName, selected } = action.payload;
      const k = keyOf(program, product, filterName);
      state.selectedValues[k] = selected;
    },

    /**
     * Clear all selected values for one program+product (e.g., when you switch tabs)
     */
    resetProgramProduct: (state, action) => {
      const { program, product } = action.payload;
      const prefix = `${program}_${product}_`;
      Object.keys(state.selectedValues).forEach((k) => {
        if (k.startsWith(prefix)) {
          delete state.selectedValues[k];
        }
      });
    },
  },
});

// Action creators
export const { setFilterSelected, resetProgramProduct } = filterSlice.actions;

// Selectors with improved null checking
export const selectAllSelectedValues = (state) => {
  return state?.filters?.selectedValues || {};
};

export const selectSelectedValue = (state, program, product, filterName) => {
  if (!state?.filters?.selectedValues) {
    return null;
  }
  const key = keyOf(program, product, filterName);
  return state.filters.selectedValues[key] ?? null;
};

export default filterSlice.reducer;
